const scope_0 = require('/Users/pieterbos/Documents/projects/protorabbit/verwonderwinkel/verwonderwinkel/.cache/gatsby-mdx/mdx-scopes-dir/7bdb96fdec00f2b4c66248c9e7b10086.js').default;
const scope_1 = require('/Users/pieterbos/Documents/projects/protorabbit/verwonderwinkel/verwonderwinkel/.cache/gatsby-mdx/mdx-scopes-dir/e43fb7ea8e5c973fc291302acf6043f3.js').default;export default 
        Object.assign({}, scope_0,
scope_1 )
    